export default (state = 0, action) => {
    if (action.type === 'UPDATE_UNREAD_COUNT' || action.type === 'MARK_AS_READ') {
        return action.payload;
    }

    return state;
}